import * as types from './types';
import { execApiWithParam } from '../api/apiActions';
import { openSuccessDialog } from '../dialog/dialogActions';
import UsernameApi from '../../apis/username';


/**
 * Forgot Username API call with no operation. Send the request
 * and carry on with your day.
 */
export const forgotUsername = (email, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.FORGOT_USERNAME,
      api: UsernameApi.forgot,
      param: email,
      successCallback: () => {
        dispatch(openSuccessDialog({
          content: 'If the email matches an account in the system, you will receive an email with your username. If the email is not received within 1 hour contact the practice office.',
        }));

        if (successCb) successCb();
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: () => {
        if (errorCb) errorCb();
      },
      useErrorDialog: true,
    }));
  };
};



// WEBPACK FOOTER //
// ./src/actions/username/usernameActions.js